import isUndefined from 'lodash/fp/isUndefined';
import type { RootDispatch, RootState } from '../../configuration/setup/store';
import { selectOrderedWaypoints } from '../../store/search/searchSelectors';
import { updateWaypointRange } from '../../store/search/searchSlice';
import type { Itinerary } from '../../store/tour/tourSlice';

export const updateWaypointsRange =
    (itineraries: Itinerary[], selectedItinerary: number) => (dispatch: RootDispatch, getState: () => RootState) => {
        const waypoints = selectOrderedWaypoints(getState());

        if (isUndefined(itineraries) || isUndefined(selectedItinerary)) {
            throw new Error('Invalid itineraries');
        }

        const itinerary = itineraries.at(selectedItinerary);
        itinerary?.sections?.forEach((it, index) => {
            const waypoint = waypoints.at(index + 1);
            if (isUndefined(waypoint)) {
                return;
            }
            dispatch(
                updateWaypointRange({
                    ...waypoint,
                    isInRange: isPositive(it.evBatteryCapacityArrival),
                })
            );
        });
    };

const isPositive = (value: number | undefined): boolean => {
    return !isUndefined(value) && value > 0;
};
